import { ChatBubbleOvalLeftIcon } from "@heroicons/react/24/outline";

interface EmptyConversationStateProps {
  segment?: "teens" | "support";
}

export function EmptyConversationState({
  segment = "teens",
}: EmptyConversationStateProps) {
  const message =
    segment === "support"
      ? "Select a conversation to start messaging"
      : "Click on a teen to view your conversation";

  return (
    <div className="flex h-full w-full flex-col items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center space-y-4">
        <div className="rounded-full bg-white p-6 shadow-sm">
          <ChatBubbleOvalLeftIcon className="h-12 w-12 text-gray-400" />
        </div>
        <p className="text-lg text-gray-600">{message}</p>
      </div>
    </div>
  );
}
